import axios from "axios";
import React, { useEffect, useState } from "react";
import { commonConfigs, urls } from "../../../config.js";
import { getUser } from "../../services/local_service.js";
import PortfolioCard from "./components/portfolio_card.jsx";
import beveatApiStaging from "../../api/staging_beveat_api.js"
import beveatApiProduction from "../../api/production_beveat_api.js"

const PortfolioLayout = ({}) => {
  const [load, setLoad] = useState(true);
  const [data, setData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const mobileNum = getUser()?.mobile;
  let getAllPortfolioProjectsUrl = ``;
  let apiHeaders;
  let apiInstance;

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (process.env.REACT_APP_ENV === "staging") {
    getAllPortfolioProjectsUrl =
      urls.baseUrl +
      commonConfigs.apiUrls.getAllPortfolioProjects(mobileNum);
    apiHeaders = commonConfigs.apiHeader;
    apiInstance = beveatApiStaging;
  } else {
    getAllPortfolioProjectsUrl =
      urls.prodUrl +
      commonConfigs.apiUrls.getAllPortfolioProjects(mobileNum);
    apiHeaders = commonConfigs.prodApiHeader;
    apiInstance = beveatApiProduction;
  }

  async function getAllPortfolioProjects() {
    await apiInstance
      .get(getAllPortfolioProjectsUrl, { headers: apiHeaders })
      .then((res) => {
        // console.log(res.data.result.data);
        setData(res.data.result.data);
        setDataList(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function onChangeSearch(e) {
    // console.log(e.target.value);
    var results = data.filter((project) =>
      project.developer_proj_name
        .toLowerCase()
        .includes(e.target.value.toLowerCase())
    );
    // console.log(results);
    setInputValue(e.target.value);
    setDataList(results);
  }

  useEffect(() => {
    if (load) {
      getAllPortfolioProjects();
    }
  }, []);

  if (!load) {
    return (
      <>
        <div style={{ width: "100%" }}>
          <div className={`mt-4 ${isMobile ? 'px-4 space-y-6' : 'desktop:space-x-8 mobile:pt-2 mobile:pb-4 mobile:space-x-2'}`}>
            {/* Portfolio Header - keep original styling */}
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: isMobile ? "24px" : "40px",
                  letterSpacing: isMobile ? "8px" : "30px",
                  fontWeight: "800",
                  color: "#3C4B64",
                  lineHeight: isMobile ? "1.2" : "1",
                }}
              >
                <h1>PORTFOLIO</h1>
                <h1>PROJECTS</h1>
              </div>
            </div>

            {/* Content Section - keep original styling */}
            <div className={`flex flex-col items-start mt-4 space-y-4 mr-4 ${isMobile ? 'items-center' : ''}`}>
              {/* Search Input - keep original styling */}
              <input
                type="text"
                value={inputValue}
                onChange={(e) => onChangeSearch(e)}
                style={{ 
                  width: isMobile ? "100%" : "450px",
                  maxWidth: isMobile ? "100%" : "450px"
                }}
                placeholder="Search projects..."
                className={`rounded-full pl-4 border-0 bg-gray-300 p-2 outline-none transition-all duration-200 focus:bg-gray-200 ${
                  isMobile ? 'w-full text-base py-3' : 'w-1/3 py-2'
                }`}
              />

              {/* Grid - keep original styling */}
              <div className={`w-full grid gap-4 mt-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3`}>
                {dataList.length > 0 ? (
                  dataList.map((item, index) => (
                    <PortfolioCard key={index} data={item} index={index} isMobile={isMobile} />
                  ))
                ) : (
                  // Empty state - keep original styling
                  <div className={`col-span-full text-center py-12 ${isMobile ? 'px-4' : ''}`}>
                    <div className="text-gray-500">
                      <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
                        {inputValue ? 'No projects found' : 'No portfolio projects yet'}
                      </h3>
                      <p className={`mt-1 ${isMobile ? 'text-sm' : 'text-base'}`}>
                        {inputValue 
                          ? `No projects match "${inputValue}". Try a different search term.`
                          : 'Your completed projects will appear here.'
                        }
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Loading state - keep original styling
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${
          isMobile ? 'h-8 w-8' : 'h-12 w-12'
        }`}></div>
        <p className={`mt-4 text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
          Loading portfolio projects...
        </p>
      </div>
    </div>
  );
};

export default PortfolioLayout;